import React, { useState } from 'react';
import { Send } from 'lucide-react';
import Swal from 'sweetalert2';

// Import local icons
import icon1 from '../../assets/img/contactuspage/1.png';
import icon2 from '../../assets/img/contactuspage/2.png';
import icon3 from '../../assets/img/contactuspage/3.png';
import icon4 from '../../assets/img/contactuspage/4.png';

const ContactUsPageForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        company: '',
        country: '',
        message: ''
    });

    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const payload = {
                ...formData,
                requirements: `Company: ${formData.company}\n\nMessage: ${formData.message}`
            };

            const response = await fetch('https://scantobimservice.us/api/send-email.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            if (!response.ok) throw new Error(`Server error: ${response.status}`);

            const result = await response.json();

            if (result.status === 'success') {
                Swal.fire({ icon: 'success', title: 'Sent! 😊', text: 'We will contact you soon.' });
                setFormData({ name: '', email: '', phone: '', company: '', country: '', message: '' });
            } else {
                throw new Error(result.message || 'Submission failed');
            }
        } catch (error) {
            Swal.fire({ icon: 'error', title: 'Error ⚠️', text: error.message });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <section className="contact-form-section">
            <div className="contact-container">
                <div className="contact-grid">
                    {/* Left side - Form */}
                    <div className="contact-form-container">
                        <h2 className="form-box-title">
                            Get In Touch With Our Experts To Turn Your Idea Into Reality.
                        </h2>

                        <form className="contact-main-form" onSubmit={handleSubmit}>
                            <div className="contact-form-row">
                                <input 
                                    type="text" 
                                    name="name"
                                    placeholder="*Full Name" 
                                    className="contact-form-field" 
                                    value={formData.name}
                                    onChange={handleChange}
                                    required 
                                />
                                <input 
                                    type="email" 
                                    name="email"
                                    placeholder="*Email Address" 
                                    className="contact-form-field" 
                                    value={formData.email}
                                    onChange={handleChange}
                                    required 
                                />
                            </div>
                            <div className="contact-form-row">
                                <input 
                                    type="tel" 
                                    name="phone"
                                    placeholder="*Phone Number" 
                                    className="contact-form-field" 
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required 
                                />
                                <input 
                                    type="text" 
                                    name="company"
                                    placeholder="Company Name" 
                                    className="contact-form-field" 
                                    value={formData.company}
                                    onChange={handleChange}
                                />
                            </div>

                            <select 
                                name="country"
                                className="contact-form-field"
                                value={formData.country}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Country</option>
                                <option value="india">India</option>
                                <option value="usa">USA</option>
                                <option value="uk">UK</option>
                                <option value="canada">Canada</option>
                            </select>

                            <textarea 
                                name="message"
                                placeholder="Write Message......" 
                                rows="6" 
                                className="contact-form-field"
                                value={formData.message}
                                onChange={handleChange}
                                required
                            ></textarea>

                            <div className="form-footer">
                                <div className="checkbox-group">
                                    <input type="checkbox" id="terms" required />
                                    <label htmlFor="terms">Accept terms and conditions from Graviton.</label>
                                </div>
                                <button type="submit" className="submit-btn" disabled={isLoading}>
                                    {isLoading ? 'Sending...' : <>{'Send Message '} <Send size={18} /></>}
                                </button>
                            </div>
                        </form>
                    </div>

                    {/* Right side - Info */}
                    <div className="contact-info-list">
                        <div className="info-item">
                            <div className="info-icon">
                                <img src={icon1.src || icon1} alt="Business Icon" className="custom-icon-img" />
                            </div>
                            <div className="info-text">
                                <p><span>Business :</span> Sales:info@chudasamaoutsourcing.com</p>
                                <p><span>WhatsApp :</span> +91 9979238180</p>
                                <p><span>Contact :</span> +91 9979238180</p>
                            </div>
                        </div>

                        <div className="info-item">
                            <div className="info-icon">
                                <img src={icon2.src || icon2} alt="Response Icon" className="custom-icon-img" />
                            </div>
                            <div className="info-text">
                                <h3 className="highlight-text">Get a response in 24 hours.</h3>
                                <p>So the project can be discussed as quickly as possible.</p>
                            </div>
                        </div>

                        <div className="info-item">
                            <div className="info-icon">
                                <img src={icon3.src || icon3} alt="Estimation Icon" className="custom-icon-img" />
                            </div>
                            <div className="info-text">
                                <h3 className="highlight-text">Detailed estimation of the project.</h3>
                                <p>The quote covers team composition, budget, delivery, and more.</p>
                            </div>
                        </div>

                        <div className="info-item">
                            <div className="info-icon">
                                <img src={icon4.src || icon4} alt="Review Icon" className="custom-icon-img" />
                            </div>
                            <div className="info-text">
                                <h3 className="highlight-text">We'll perform a free code review.</h3>
                                <p>In case of an existing system, a code analysis will ensure a better quote.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactUsPageForm;
